import { HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from 'utility/constants';

type CloseButtonProps = {
  onClose: () => void;
};

const CloseButton = ({ onClose }: CloseButtonProps) => {
  return (
    <button
      type="button"
      className="close hmf-p-xxs hmf-display-flex hmf-flex-column hmf-align-items-center hmf-position-absolute"
      tabIndex={0}
      onClick={onClose}
      onKeyDown={(event) => {
        if (event.keyCode === KEY_CODES.SPACE || event.keyCode === KEY_CODES.ENTER) {
          onClose();
        }
      }}>
      <HomefieldIconSignCancel width="24px" height="24px" />
      <p className="hmf-body-bold-s label-inverse-base hmf-m-0">Close</p>
    </button>
  );
};

export default CloseButton;
